import { createContext } from 'react';

export const ComponentConfigContext = createContext();
